import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchfilterDateRange2',
  pure: true,
  standalone: false,
})
export class SearchfilterDateRangePipe2 implements PipeTransform {
  transform(value: Array<any>, start?: any, end?: any) {
    if (!start || !end) {
      return value;
    }

    const startDate = new Date(start);
    const endDate = new Date(end);

    return (value ?? []).filter((activity) => {
      const from = activity.from ? new Date(activity.from) : null;
      const to = activity.to ? new Date(activity.to) : null;
      const activityDate = activity.activityDate ? new Date(activity.activityDate) : null;

      // Caso 1: L'attività ha sia `from` che `to` (periodo specificato)
      if (from && to) {
        // Include l'attività se il range di filtraggio si sovrappone a quello dell'attività
        const isStartWithinFilter = from <= endDate && from >= startDate;
        const isEndWithinFilter = to <= endDate && to >= startDate;
        const doesActivitySpanFilter = from <= startDate && to >= endDate;
        const doesFilterOverlapActivity = from <= endDate && to >= startDate;

        return (
          isStartWithinFilter ||
          isEndWithinFilter ||
          doesActivitySpanFilter ||
          doesFilterOverlapActivity
        );
      }

      // Caso 2: se `from` e `to` sono null, usare `activityDate`
      if (activityDate && from == null && to == null) {
        return activityDate >= startDate && activityDate <= endDate;
      }

      // Caso 3: se nessuna data è disponibile, escludere l'attività
      return false;
    });
  }
}
